export default "__VITE_ASSET__DPG2wAT5__"